import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "utils/api";
import { setAnalyticsUserId } from "utils/analytics";
import { SIGN_IN_MODAL } from "utils/constants";

export const fetchProfile = createAsyncThunk("user/fetchProfile", async (firebaseToken) => {
  try {
    const respose = await api.getProfile(firebaseToken);
    const profileData = respose.data;
    return profileData;
  } catch (e) {
    console.error(e);
  }
});

const initialState = {
  authUser: null,
  firebaseToken: null,
  profile: {
    apaleoReservations: [],
  },
  mobileAppUser: false,
  showMemberBanner: true,
  hasChosenCommunicationPreferences: true,
  triggerSignInSignUpModal: SIGN_IN_MODAL.NONE,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    signInUser: (state, action) => {
      state.authUser = action.payload;
      state.showMemberBanner = false;

      setAnalyticsUserId(action.payload.id);
    },
    signOutUser: () => initialState,
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setFirebaseToken: (state, action) => {
      state.firebaseToken = action.payload;
    },
    removeReservationFromProfile: (state, action) => {
      const reservationToRemove = action.payload;
      const profileDeepClone = JSON.parse(JSON.stringify(state.profile));
      profileDeepClone.apaleoReservations = profileDeepClone.apaleoReservations.filter(
        (reservation) => {
          return reservation.id !== reservationToRemove.id;
        },
      );
      state.profile = profileDeepClone;
    },
    setMobileAppUser: (state, action) => {
      state.mobileAppUser = action.payload;
    },
    setShowMemberBanner: (state, action) => {
      state.showMemberBanner = action.payload;
    },
    setHasChosenCommunicationPreferences: (state, action) => {
      state.hasChosenCommunicationPreferences = action.payload;
    },
    setTriggerSignInSignUpModal: (state, action) => {
      state.triggerSignInSignUpModal = action.payload; // "signIn", "signUp", or null
    },
  },
  extraReducers: {
    [fetchProfile.fulfilled]: (state, action) => {
      state.profile = action.payload;
    },
  },
});

export const {
  signInUser,
  signOutUser,
  setProfile,
  setFirebaseToken,
  removeReservationFromProfile,
  setMobileAppUser,
  setShowMemberBanner,
  setHasChosenCommunicationPreferences,
  setTriggerSignInSignUpModal,
} = userSlice.actions;
export default userSlice.reducer;
